import type { ITextDialogAttributes } from "../types";

/**
 * Collection of constants for application-wide usage.
 */
export const GlobalConstants = {
    /**
     * Variables
     */
    editingSessionTimestamp: 'sessionTimestamp',
    /**
     * If true callout annotations will enforce `GlobalConstants.default.fontFamily`
     * fonts before rendering document.
     */
    forceDefaultFont: false,
    highlightAnimation: 'animation:dash 0.5s linear infinite',
    highlightDasharray: 'stroke-dasharray:6,6',
    markSelectClassName: 'svg',
    markSelectSelector: '#svg',
    /**
     * Pixels height of the measure dialog overlay.
     */
    measureDialogHeight: 237,
    printQuality: 300, // dpi
    sidebarWidth: 350,
    searchResultHighlightColor: '#FBC62A',

    /**
     * Structured constants
     */

    anonymousUser: {
        adCommonName: 'Anonymous',
        name: 'Anonymous',
        nickname: 'anonymous',
        picture:
            'https://s.gravatar.com/avatar/63ea0b3d7e56ea71fb18cfbaa8968000?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fcs.png',
        sub: 'auth0|anonymous',
        updated_at: '2022-12-21T08:10:25.251Z',
        fullname: 'Anonymous',
        dataProtection: '1',
        firstName: 'Infoclient',
        lastName: 'dev',
        lastPasswordReset: '13/03/2019',
        email: 'local@mail.de',
    },

    classes: {
        active: 'active',
        current_annot: 'current-annot',

        fv__mark_selection_blank: 'fv__mark-selection-blank',

        fv__pdf_page_annot_container: 'fv__pdf-page-annot-container',
        pdf_page_markup_annot_container: 'pdf-page-markup-annot-container',

        fv__pdf_page_annot_handler_container: 'fv__pdf-page-annot-handler-container',
        pdf_page_markup_annot_handler_container: 'pdf-page-markup-annot-handler-container',

        fv__shape_control: 'fv__shape-control',
        fv__pdf_page_annot_handler_rect: 'fv__pdf-page-annot-handler-rect',

        fv__shape_control_move_area: 'fv__shape-control-move-area',

        fv__shape_controller: 'fv__shape-controller',
        fv__pdf_annot_line_point: 'fv__pdf-annot-line-point',
        fv__pdf_annot_line_point_item: 'fv__pdf-annot-line-point-item',
    },

    /**
     * Collection of CSS class selectors.
     */
    classSelectors: {
        /**
         * Collection of CSS class selectors for containers.
         */
        containers: {
            fv__pdf_page_annot_container: '.fv__pdf-page-annot-container',
        },

        /**
         * Collection of CSS class selectors for resize-grips.
         */
        resizeGrips: {
            fv__pdf_annot_line_point: '.fv__pdf-annot-line-point',
            fv__pdf_annot_line_point_item: '.fv__pdf-annot-line-point-item',
            fv__shape_controller: '.fv__shape-controller',
        },

        /**
         * Collection of CSS class selectors for move-areas.
         */
        moveAreas: {
            fv__shape_control_move_area: '.fv__shape-control-move-area',
        },
    },

    customHandlerNames: {
        createArrow: 'createLine',
        createPolygonCloud: 'createCloud',
    },

    default: {
        fontAlignment: 'left',
        fontFamily: 'Cousine',
        fontSize: '14pt',
        fontStyles: {
            align: [true, false, false, false],
            bold: false,
            italic: false,
            underline: false,
            strikeout: false,
        } as ITextDialogAttributes,
    },

    emptyUserStamp: {
        category: 'unknown',
        height: 32,
        id: '?',
        name: 'unknown',
        scale: 1.0,
        width: 32,
    },

    /**
     * Collection of environment variable names.
     */
    environmentVariables: {
        BuildNumber: 'REACT_APP_BUILD_NUMBER',
    },

    htmlModels: {
        annotContainer: {
            classes() {
                return [
                    GlobalConstants.classes.fv__pdf_page_annot_container,
                    GlobalConstants.classes.pdf_page_markup_annot_container,
                ];
            },
        },

        handlerContainer: {
            classes() {
                return [
                    GlobalConstants.classes.fv__pdf_page_annot_handler_container,
                    GlobalConstants.classes.pdf_page_markup_annot_handler_container,
                    GlobalConstants.classes.active,
                ];
            },
        },

        controlDiv: {
            classes() {
                return [
                    GlobalConstants.classes.fv__shape_control,
                    GlobalConstants.classes.fv__pdf_page_annot_handler_rect,
                ];
            },
        },

        moveArea: {
            classes() {
                return [GlobalConstants.classes.fv__shape_control_move_area];
            },
        },
    },

    ids: {
        rich_text_modal_container: 'rich-text-modal_container',
    },

    supported: {
        documents: ['.pdf'],
        images: ['.jpg', 'jpeg', '.png', '.tif'],
    },
};
